var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "service-type" },
    [
      _c(
        "base-dialog",
        {
          attrs: {
            okBtnText: _vm.$t("chats.go-my-services"),
            okFn: function() {
              _vm.$helpers.goToWebApp(
                "HomeProfesional#/services",
                _vm.$apiToken
              )
            },
            cancelFn: function() {
              _vm.activateInterconsultationsModal = false
            }
          },
          model: {
            value: _vm.activateInterconsultationsModal,
            callback: function($$v) {
              _vm.activateInterconsultationsModal = $$v
            },
            expression: "activateInterconsultationsModal"
          }
        },
        [
          _c("p", {
            domProps: {
              innerHTML: _vm._s(_vm.$t("chats.go-activate-interconsultations"))
            }
          })
        ]
      ),
      _vm._v(" "),
      _vm._l(_vm.activeServices, function(service) {
        return _c(
          "div",
          {
            key: service.name,
            staticClass: "service-type-block",
            on: { click: service.action }
          },
          [
            _c("base-icon", {
              staticClass: "d-block mb-3",
              attrs: {
                src: service.icon,
                alt: "",
                height: _vm.iconSize,
                width: _vm.iconSize,
                color: _vm.BLUE_COLOUR
              }
            }),
            _vm._v(" "),
            _c("div", {
              staticClass: "service-name mt-1",
              domProps: { innerHTML: _vm._s(service.name) }
            }),
            _vm._v(" "),
            service.name === _vm.$t("professionalServices.facilityRent")
              ? _c(
                  "b-badge",
                  {
                    class: { blink: _vm.blinkSoonLabelActive },
                    attrs: { variant: "primary" }
                  },
                  [_vm._v(_vm._s(_vm.$t("soon-label")))]
                )
              : _vm._e()
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1a2b14a0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a2b14a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/webapp/professional/interconsultations/SearchBlocksProfessional.vue
// module id = 2958
// module chunks = 5 14 51